import { defineMessages } from 'react-intl';

export const applyTemplate = defineMessages({
  'dt:apply_template:credit_certificate': {
    id: 'apply_template.credit_certificate.title',
    defaultMessage: 'Credit certificate',
  },
  'dt:apply_template:entity': {
    id: 'apply_template.entity.title',
    defaultMessage: 'Entity',
  },
  'dt:apply_template:sale': {
    id: 'apply_template.sale.title',
    defaultMessage: 'Sale',
  },
  'dt:apply_template:sale:admin': {
    id: 'apply_template.sale.admin.title',
    defaultMessage: 'Sale (Admin)',
  },
  'dt:apply_template:oms:order': {
    id: 'apply_template.oms.order.title',
    defaultMessage: 'Order management (Order)',
  },
  'dt:apply_template:purchase': {
    id: 'apply_template.purchase.title',
    defaultMessage: 'Purchase',
  },
  'dt:apply_template:till': {
    id: 'apply_template.till.title',
    defaultMessage: 'Till',
  },
  'dt:apply_template:search_record': {
    id: 'apply_template.search_record.title',
    defaultMessage: 'Search record',
  },
  'dt:apply_template:item': {
    id: 'apply_template.item.title',
    defaultMessage: 'Item',
  },
  'dt:apply_template:inventory': {
    id: 'apply_template.inventory.title',
    defaultMessage: 'Inventory',
  },
});
